export const ERROR = {
  ERROR: "APP_ERROR", // Default fallback type, when type is unknown
  ADD_ERROR: "ADD_ERROR",
  ACKNOWLEDGE_ERROR: "ACKNOWLEDGE_ERROR",
};

export const APP_WARNING = {
  WARNING: "APP_WARNING", // Default fallback type, when type is unknown
  ADD_WARNING: "ADD_APP_WARNING",
  ACKNOWLEDGE_WARNING: "ACKNWOLEDGE_APP_WARNING",
};

export const testActions = {
  TEST_REQ: "TEST_REQ",
  TEST_REQ_FULFILLED: "TEST_REQ_FULFILLED",
  TEST_REQ_REJECTED: "TEST_REQ_REJECTED",
  TEST_SAML_AUTH: "TEST_SAML_AUTH",
  TEST_SAML_AUTH_FULFILLED: "TEST_SAML_AUTH_FULFILLED",
  TEST_SAML_AUTH_REJECTED: "TEST_SAML_AUTH_REJECTED",
};

export const GENERIC_ACTIONS = {
  REQUEST: "GENERIC_REQUEST",
  FULFILLED: "GENERIC_FULFILLED",
  REJECTED: "GENERIC_REJECTED",
};

export const UPDATE_NOTES = {
  FETCH: "FETCH_UPDATE_NOTES",
  FETCH_FULFILLED: "FETCH_UPDATE_NOTES_FULFILLED",
  FETCH_REJECTED: "FETCH_UPDATE_NOTES_REJECTED",
  FETCH_ALL: "FETCH_ALL_UPDATE_NOTES",
  FETCH_ALL_FULFILLED: "FETCH_ALL_UPDATE_NOTES_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_UPDATE_NOTES_REJECTED",
};

/**
 * @constant menuActions
 * @summary Redux action constants for the main menu
 */
export const menuActions = {
  SELECT_MENU_ITEM: "SELECT_MENU_ITEM",
  BUILD_MENU: "BUILD_MENU",
  BUILD_MENU_SUCCESS: "BUILD_MENU_SUCCESS",
  FETCH_MENU_DATA: "FETCH_MENU_DATA",
  FETCH_MENU_DATA_FULFILLED: "FETCH_MENU_DATA_FULFILLED",
  FETCH_MENU_DATA_REJECTED: "FETCH_MENU_DATA_REJECTED",
  RESET_MENU_ON_LOGOUT: "RESET_MENU_ON_LOGOUT",
};

// Main tab actions
export const MAINTAB = {
  ADD: "ADD_MAINTAB",
  CLOSE: "CLOSE_MAINTAB",
  CLOSE_ALL: "CLOSE_ALL_MAINTABS",
  SELECT: "SELECT_MAINTAB",
  MARK_DIRTY: "MARK_MAINTAB_DIRTY",
  UNMARK_DIRTY: "UNMARK_MAINTAB_DIRTY",
  CHANGE_LABEL: "CHANGE_MAINTAB_LABEL",
  CHANGE_METADATA: "CHANGE_MAINTAB_METADATA",
  RESERVE_TAB_ID: "RESERVE_MAINTAB_ID",
  UNRESERVE_TAB_ID: "UNRESERVE_MAINTAB_ID",
  APPLY_TAB_ID: "APPLY_MAINTAB_ID",
};

// Notification actions
export const NOTIFICATION = {
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  DISMISS_NOTIFICATION: "DISMISS_NOTIFICATION",
  FETCH_NOTIFICATIONS: "FETCH_NOTIFICATIONS",
  FETCH_NOTIFICATIONS_FULFILLED: "FETCH_NOTIFICATIONS_FULFILLED",
  FETCH_NOTIFICATIONS_REJECTED: "FETCH_NOTIFICATIONS_REJECTED",
};

// FeederList actions
export const FEEDERLISTS = {
  FETCH: "FETCH_FEEDERLISTS",
  FETCH_FULFILLED: "FETCH_FEEDERLISTS_FULFILLED",
  FETCH_REJECTED: "FETCH_FEEDERLISTS_REJECTED",
  REFRESH: "REFRESH_FEEDERLISTS",
  REFRESH_FULFILLED: "REFRESH_FEEDERLISTS_FULFILLED",
  REFRESH_FULFILLED_ALT: "REFRESH_FEEDERLISTS_FULFILLED_ALT",
  REFRESH_REJECTED: "REFRESH_FEEDERLISTS_REJECTED",
  CLEAR_ALL: "CLEAR_ALL_FEEDERLISTS",
  FETCH_LOOKUP_LISTS: "FETCH_LOOKUP_LISTS",
  FETCH_LOOKUP_LISTS_FULFILLED: "FETCH_LOOKUP_LISTS_FULFILLED",
  FETCH_LOOKUP_LISTS_REJECTED: "FETCH_LOOKUP_LISTS_REJECTED",
  FETCH_ALL_TRADES: "FETCH_ALL_TRADES",
  FETCH_ALL_TRADES_FULFILLED: "FETCH_ALL_TRADES_FULFILLED",
  FETCH_ALL_TRADES_REJECTED: "FETCH_ALL_TRADES_REJECTED",
  FETCH_LOCATION_TYPES: "FETCH_LOCATION_TYPES",
  FETCH_LOCATION_TYPES_FULFILLED: "FETCH_LOCATION_TYPES_FULFILLED",
  FETCH_LOCATION_TYPES_REJECTED: "FETCH_LOCATION_TYPES_REJECTED",
};

export const CONTRACTOR = {
  // Contractors
  ADD: "ADD_CONTRACTOR",
  ADD_FULFILLED: "ADD_CONTRACTOR_FULFILLED",
  ADD_REJECTED: "ADD_CONTRACTOR_REJECTED",
  DELETE: "DELETE_CONTRACTOR",
  DELETE_FULFILLED: "DELETE_CONTRACTOR_FULFILLED",
  DELETE_REJECTED: "DELTE_CONTRACTOR_REJECTED",
  EDIT: "EDIT_CONTRACTOR",
  EDIT_FULFILLED: "EDIT_CONTRACTOR_FULFILLED",
  EDIT_REJECTED: "EDIT_CONTRACTOR_REJECTED",
  SET_SEARCH_WAITINGFOR: "SET_CONTRACTOR_SEARCH_WAITINGFOR",
  CLEAR_DETAILS: "CLEAR_CONTRACTOR_DETAILS",
  CLEAR_ALL_DETAILS: "CLEAR_ALL_CONTRACTOR_DETAILS",
  FETCH_DETAILS: "FETCH_CONTRACTOR_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_CONTRACTOR_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_CONTRACTOR_DETAILS_REJECTED",
  CLEAR_LIST: "CLEAR_CONTRACTOR_LIST",
  CLEAR_MISC_SESSION_DATA: "CLEAR_CONTRACTOR_MISC_SESSION_DATA",
  FETCH_ALL: "FETCH_ALL_CONTRACTORS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_CONTRACTORS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_CONTRACTORS_REJECTED",
  FETCH_ALL_FOR_PROJECT: "FETCH_ALL_CONTRACTORS_FOR_PROJECT",
  FETCH_ALL_FOR_PROJECT_FULFILLED: "FETCH_ALL_CONTRACTORS_FOR_PROJECT_FULFILLED",
  FETCH_ALL_FOR_PROJECT_REJECTED: "FETCH_ALL_CONTRACTORS_FOR_PROJECT_REJECTED",
  // Project Contractors
  FETCH_PROJECT_CONTRACTOR_DETAILS: "FETCH_PROJECT_CONTRACTOR_DETAILS",
  FETCH_PROJECT_CONTRACTOR_DETAILS_FULFILLED:
    "FETCH_PROJECT_CONTRACTOR_DETAILS_FULFILLED",
  FETCH_PROJECT_CONTRACTOR_DETAILS_REJECTED: "FETCH_PROJECT_CONTRACTOR_DETAILS_REJECTED",
  CLEAR_PROJECT_CONTRACTOR_DETAILS: "CLEAR_PROJECT_CONTRACTOR_DETAILS",
  FETCH_PROJECT_CONTRACTORS_WITH_LINKS: "FETCH_PROJECT_CONTRACTORS_WITH_LINKS",
  FETCH_PROJECT_CONTRACTORS_WITH_LINKS_FULFILLED:
    "FETCH_PROJECT_CONTRACTORS_WITH_LINKS_FULFILLED",
  FETCH_PROJECT_CONTRACTORS_WITH_LINKS_REJECTED:
    "FETCH_PROJECT_CONTRACTORS_WITH_LINKS_REJECTED",
  EDIT_PROJECT_CONTRACTORS: "EDIT_PROJECT_CONTRACTORS",
  EDIT_PROJECT_CONTRACTORS_FULFILLED: "EDIT_PROJECT_CONTRACTORS_FULFILLED",
  EDIT_PROJECT_CONTRACTORS_REJECTED: "EDIT_PROJECT_CONTRACTORS_REJECTED",
  EDIT_PROJECT_CONTRACTOR_DETAILS: "EDIT_PROJECT_CONTRACTOR_DETAILS",
  EDIT_PROJECT_CONTRACTOR_DETAILS_FULFILLED: "EDIT_PROJECT_CONTRACTOR_DETAILS_FULFILLED",
  EDIT_PROJECT_CONTRACTOR_DETAILS_REJECTED: "EDIT_PROJECT_CONTRACTOR_DETAILS_REJECTED",
};

export const LABOR = {
  GENERIC_REQUEST: "LABOR_GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "LABOR_GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "LABOR_GENERIC_REQUEST_REJECTED",
  FETCH_ALL: "FETCH_ALL_LABORS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_LABORS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_LABORS_REJECTED",
  DOWNLOAD_ALL: "DOWNLOAD_ALL_LABORS",
  DOWNLOAD_ALL_FULFILLED: "DOWNLOAD_ALL_LABORS_FULFILLED",
  DOWNLOAD_ALL_REJECTED: "DOWNLOAD_ALL_LABORS_REJECTED",
  FETCH_ALL_FOR_PROJECT: "FETCH_PROJECT_LABORS",
  FETCH_ALL_FOR_PROJECT_FULFILLED: "FETCH_PROJECT_LABORS_FULFILLED",
  FETCH_ALL_FOR_PROJECT_REJECTED: "FETCH_PROJECT_LABORS_REJECTED",
  FETCH_DETAILS: "FETCH_LABOR_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_LABOR_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_LABOR_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_LABOR_DETAILS",
  ADD: "ADD_LABOR",
  ADD_FULFILLED: "ADD_LABOR_FULFILLED",
  ADD_REJECTED: "ADD_LABOR_REJECTED",
  ADD_TO_PROJECT: "ADD_PROJECT_LABOR",
  ADD_TO_PROJECT_FULFILLED: "ADD_PROJECT_LABOR_FULFILLED",
  ADD_TO_PROJECT_REJECTED: "ADD_PROJECT_LABOR_REJECTED",
  EDIT: "EDIT_LABOR",
  EDIT_FULFILLED: "EDIT_LABOR_FULFILLED",
  EDIT_REJECTED: "EDIT_LABOR_REJECTED",
  DELETE: "DELETE_LABOR",
  DELETE_FULFILLED: "DELETE_LABOR_FULFILLED",
  DELETE_REJECTED: "DELETE_LABOR_REJECTED",
  EDIT_PROJECT_LABOR: "EDIT_PROJECT_LABOR",
  EDIT_PROJECT_LABOR_FULFILLED: "EDIT_PROJECT_LABOR_FULFILLED",
  EDIT_PROJECT_LABOR_REJECTED: "EDIT_PROJECT_LABOR_REJECTED",
  VERIFY: "VERIFY_LABOR",
  VERIFY_FULFILLED: "VERIFY_LABOR_FULFILLED",
  VERIFY_REJECTED: "VERIFY_LABOR_REJECTED",
};

export const LABORCREW = {
  GENERIC_REQUEST: "LABORCREW_GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "LABORCREW_GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "LABORCREW_GENERIC_REQUEST_REJECTED",
  ADD: "ADD_LABOR_CREW",
  ADD_FULFILLED: "ADD_LABOR_CREW_FULFILLED",
  ADD_REJECTED: "ADD_LABOR_CREW_REJECTED",
  EDIT: "EDIT_LABOR_CREW",
  EDIT_FULFILLED: "EDIT_LABOR_CREW_FULFILLED",
  EDIT_REJECTED: "EDIT_LABOR_CREW_REJECTED",
  DELETE: "DELETE_LABOR_CREW",
  DELETE_FULFILLED: "DELETE_LABOR_CREW_FULFILLED",
  DELETE_REJECTED: "DELETE_LABOR_CREW_REJECTED",
  FETCH_DETAILS: "FETCH_LABOR_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_LABOR_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_DETAILS_REJECTED",
  FETCH_ALL: "FETCH_ALL_LABOR_CREWS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_LABOR_CREWS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_LABOR_CREWS_REJECTED",
};

export const EQUIPMENT = {
  GENERIC_REQUEST: "EQUIPMENT_GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "EQUIPMENT_GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "EQUIPMENT_GENERIC_REQUEST_REJECTED",
  FETCH_ALL: "FETCH_ALL_EQUIPMENT",
  FETCH_ALL_FULFILLED: "FETCH_ALL_EQUIPMENT_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_EQUIPMENT_REJECTED",
  FETCH_DETAILS: "FETCH_EQUIPMENT_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_EQUIPMENT_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_EQUIPMENT_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_EQUIPMENT_DETAILS",
  DOWNLOAD_ALL: "DOWNLOAD_ALL_EQUIPMENT",
  DOWNLOAD_ALL_FULFILLED: "DOWNLOAD_ALL_EQUIPMENT_FULFILLED",
  DOWNLOAD_ALL_REJECTED: "DOWNLOAD_ALL_EQUIPMENT_REJECTED",
  ADD: "ADD_EQUIPMENT",
  ADD_FULFILLED: "ADD_EQUIPMENT_FULFILLED",
  ADD_REJECTED: "ADD_EQUIPMENT_REJECTED",
  EDIT: "EDIT_EQUIPMENT",
  EDIT_FULFILLED: "EDIT_EQUIPMENT_FULFILLED",
  EDIT_REJECTED: "EDIT_EQUIPMENT_REJECTED",
  DELETE: "DELETE_EQUIPMENT",
  DELETE_FULFILLED: "DELETE_EQUIPMENT_FULFILLED",
  DELETE_REJECTED: "DELETE_EQUIPMENT_REJECTED",
};

// Project action constants
export const PROJECT = {
  GENERIC_REQUEST: "GENERIC_PROJECT_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_PROJECT_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_PROJECT_REQUEST_REJECTED",
  ADD: "ADD_PROJECT",
  ADD_FULFILLED: "ADD_PROJECT_FULFILLED",
  ADD_REJECTED: "ADD_PROJECT_REJECTED",
  INITIATE: "INITIATE_PROJECT",
  INITIATE_FULFILLED: "INITIATE_PROJECT_FULFILLED",
  INITIATE_REJECTED: "INITIATE_PROJECT_REJECTED",
  EDIT: "EDIT_PROJECT",
  EDIT_FULFILLED: "EDIT_PROJECT_FULFILLED",
  EDIT_REJECTED: "EDIT_PROJECT_REJECTED",
  FETCH_TYPES: "FETCH_PROJECT_TYPES",
  FETCH_TYPES_FULFILLED: "FETCH_PROJECT_TYPES_FULFILLED",
  FETCH_TYPES_REJECTED: "FETCH_PROJECT_TYPES_REJECTED",
  FETCH_DETAILS: "FETCH_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_PROJECT_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_PROJECT_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_PROJECT_DETAILS",
  FETCH_JOBSTAMP: "FETCH_JOBSTAMP",
  FETCH_JOBSTAMP_FULFILLED: "FETCH_JOBSTAMP_FULFILLED",
  FETCH_JOBSTAMP_REJECTED: "FETCH_JOBSTAMP_REJECTED",
  FETCH_PROJECT_UNITS: "FETCH_PROJECT_UNITS",
  FETCH_PROJECT_UNITS_FULFILLED: "FETCH_PROJECT_UNITS_FULFILLED",
  FETCH_PROJECT_UNITS_REJECTED: "FETCH_PROJECT_UNITS_REJECTED",
  FETCH_ALL: "FETCH_ALL_PROJECTS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_PROJECTS_FULFILLED",
  FETCH_ALL_PAGED_FULFILLED: "FETCH_ALL_PROJECTS_PAGED_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_PROJECTS_REJECTED",
  SET_PROJECT_WAITINGFOR: "SET_PROJECT_WAITINGFOR",
  CLEAR_LIST: "CLEAR_PROJECT_LIST",
  FETCH_SUGGESTIONS: "FETCH_PROJECT_SUGGESTIONS",
  FETCH_SUGGESTIONS_FULFILLED: "FETCH_PROJECT_SUGGESTIONS_FULFILLED",
  FETCH_SUGGESTIONS_REJECTED: "FETCH_PROJECT_SUGGESTIONS_REJECTED",
  FETCH_ALL_DROPDOWN: "FETCH_ALL_PROJECTS_DROPDOWN",
  FETCH_ALL_DROPDOWN_FULFILLED: "FETCH_ALL_PROJECTS_DROPDOWN_FULFILLED",
  FETCH_ALL_DROPDOWN_REJECTED: "FETCH_ALL_PROJECTS_DROPDOWN_REJECTED",
  FETCH_ASSIGNED_PROJECTS_FOR_USER: "FETCH_ASSIGNED_PROJECTS_FOR_USER",
  FETCH_ASSIGNED_PROJECTS_FOR_USER_FULFILLED:
    "FETCH_ASSIGNED_PROJECTS_FOR_USER_FULFILLED",
  FETCH_ASSIGNED_PROJECTS_FOR_USER_REJECTED: "FETCH_ASSIGNED_PROJECTS_FOR_USER_REJECTED",
  FETCH_PROJECT_ASSIGNMENTS: "FETCH_PROJECT_ASSIGNMENTS",
  FETCH_PROJECT_ASSIGNMENTS_FULFILLED: "FETCH_PROJECT_ASSIGNMENTS_FULFILLED",
  FETCH_PROJECT_ASSIGNMENTS_REJECTED: "FETCH_PROJECT_ASSIGNMENTS_REJECTED",
  FETCH_PROJECT_ASSIGNMENT_HISTORY: "FETCH_PROJECT_ASSIGNMENT_HISTORY",
  FETCH_PROJECT_ASSIGNMENT_HISTORY_FULFILLED:
    "FETCH_PROJECT_ASSIGNMENT_HISTORY_FULFILLED",
  FETCH_PROJECT_ASSIGNMENT_HISTORY_REJECTED: "FETCH_PROJECT_ASSIGNMENT_HISTORY_REJECTED",
  FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST: "FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST",
  FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST_FULFILLED:
    "FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST_FULFILLED",
  FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST_REJECTED:
    "FETCH_PROJECT_ASSIGNMENTS_PROJECTLIST_REJECTED",
  SAVE_PROJECT_ASSIGNMENTS: "SAVE_PROJECT_ASSIGNMENTS",
  SAVE_PROJECT_ASSIGNMENTS_FULFILLED: "SAVE_PROJECT_ASSIGNMENTS_FULFILLED",
  SAVE_PROJECT_ASSIGNMENTS_REJECTED: "SAVE_PROJECT_ASSIGNMENTS_REJECTED",
  SAVE_PROJECT_UNITS: "SAVE_PROJECT_UNITS",
  SAVE_PROJECT_UNITS_FULFILLED: "SAVE_PROJECT_UNITS_FULFILLED",
  SAVE_PROJECT_UNITS_REJECTED: "SAVE_PROJECT_UNITS_REJECTED",
  FETCH_PROJECT_ROLES: "FETCH_PROJECT_ROLES",
  FETCH_PROJECT_ROLES_FULFILLED: "FETCH_PROJECT_ROLES_FULFILLED",
  FETCH_PROJECT_ROLES_REJECTED: "FETCH_PROJECT_ROLES_REJECTED",
  CLEAR_ALL_PROJECT_DATA: "CLEAR_ALL_PROJECT_DATA",
};

// Project component actions
export const PROJCOMP = {
  FETCH_WORKDAY_NUMBER: "FETCH_WORKDAY_NUMBER",
  FETCH_WORKDAY_NUMBER_FULFILLED: "FETCH_WORKDAY_NUMBER_FULFILLED",
  FETCH_WORKDAY_NUMBER_REJECTED: "FETCH_WORKDAY_NUMBER_REJECTED",
};

export const ITEM = {
  GENERIC_REQUEST: "GENERIC_ITEM_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_ITEM_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_ITEM_REQUEST_REJECTED",
  ADD: "ADD_ITEM",
  ADD_FULFILLED: "ADD_ITEM_FULFILLED",
  ADD_REJECTED: "ADD_ITEM_REJECTED",
  DELETE: "DELETE_ITEM",
  DELETE_FULFILLED: "DELETE_ITEM_FULFILLED",
  DELETE_REJECTED: "DELETE_ITEM_REJECTED",
  EDIT: "EDIT_ITEM",
  EDIT_FULFILLED: "EDIT_ITEM_FULFILLED",
  EDIT_REJECTED: "EDIT_ITEM_REJECTED",
  FETCH_ALL: "FETCH_BID_ITEMS",
  FETCH_ALL_FULFILLED: "FETCH_ITEMS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ITEMS_REJECTED",
  FETCH_DETAILS: "FETCH_ITEM_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_ITEM_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_ITEM_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_ITEM_DETAILS",
  FETCH_QUANTITIES_TO_DATE: "FETCH_ITEM_QUANTITIES_TO_DATE",
  FETCH_QUANTITIES_TO_DATE_FULFILLED: "FETCH_ITEM_QUANTITIES_TO_DATE_FULFILLED",
  FETCH_QUANTITIES_TO_DATE_REJECTED: "FETCH_ITEM_QUANTITIES_TO_DATE_REJECTED",
};

export const CCO = {
  GENERIC_REQUEST: "GENERIC_CCO_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_CCO_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_CCO_REQUEST_REJECTED",
  ADD: "ADD_CCO",
  ADD_FULFILLED: "ADD_CCO_FULFILLED",
  ADD_REJECTED: "ADD_CCO_REJECTED",
  DELETE: "DELETE_CCO",
  DELETE_FULFILLED: "DELETE_CCO_FULFILLED",
  DELETE_REJECTED: "DELETE_CCO_REJECTED",
  EDIT: "EDIT_CCO",
  EDIT_FULFILLED: "EDIT_CCO_FULFILLED",
  EDIT_REJECTED: "EDIT_CCO_REJECTED",
  FETCH_ALL: "FETCH_ALL_CCOS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_CCOS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_CCOS_REJECTED",
  FETCH_DETAILS: "FETCH_CCO_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_CCO_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_CCO_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_CCO_DETAILS",
};

export const PENDINGISSUE = {
  GENERIC_REQUEST: "GENERIC_PEND_ISSUE_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_PEND_ISSUE_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_PEND_ISSUE_REQUEST_REJECTED",
  ADD: "ADD_PEND_ISSUE",
  ADD_FULFILLED: "ADD_PEND_ISSUE_FULFILLED",
  ADD_REJECTED: "ADD_PEND_ISSUE_REJECTED",
  DELETE: "DELETE_PEND_ISSUE",
  DELETE_FULFILLED: "DELETE_PEND_ISSUE_FULFILLED",
  DELETE_REJECTED: "DELETE_PEND_ISSUE_REJECTED",
  EDIT: "EDIT_PEND_ISSUE",
  EDIT_FULFILLED: "EDIT_PEND_ISSUE_FULFILLED",
  EDIT_REJECTED: "EDIT_PEND_ISSUE_REJECTED",
  FETCH_DETAILS: "FETCH_PEND_ISSUE_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_PEND_ISSUE_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_PEND_ISSUE_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_PEND_ISSUE_DETAILS",
  FETCH_ALL: "FETCH_ALL_PEND_ISSUES",
  FETCH_ALL_FULFILLED: "FETCH_ALL_PEND_ISSUES_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_PEND_ISSUES_REJECTED",
};

export const LOCATION = {
  GENERIC_REQUEST: "GENERIC_LOCATION_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_LOCATION_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_LOCATION_REQUEST_REJECTED",
  ADD: "ADD_LOCATION",
  ADD_FULFILLED: "ADD_LOCATION_FULFILLED",
  ADD_REJECTED: "ADD_LOCATION_REJECTED",
  DELETE: "DELETE_LOCATION",
  DELETE_FULFILLED: "DELETE_LOCATION_FULFILLED",
  DELETE_REJECTED: "DELETE_LOCATION_REJECTED",
  EDIT: "EDIT_LOCATION",
  EDIT_FULFILLED: "EDIT_LOCATION_FULFILLED",
  EDIT_REJECTED: "EDIT_LOCATION_REJECTED",
  FETCH_ALL: "FETCH_ALL_LOCATIONS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_LOCATIONS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_LOCATIONS_REJECTED",
  FETCH_DETAILS: "FETCH_LOCATION_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_LOCATION_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_LOCATION_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_LOCATION_DETAILS",
  VALIDATE_GENLOCS: "VALIDATE_GENLOCS",
  VALIDATE_GENLOCS_FULFILLED: "VALIDATE_GENLOCS_FULFILLED",
  VALIDATE_GENLOCS_REJECTED: "VALIDATE_GENLOCS_REJECTED",
};

export const KEYWORD = {
  GENERIC_REQUEST: "GENERIC_KEYWORD_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_KEYWORD_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_KEYWORD_REQUEST_REJECTED",
  ADD: "ADD_KEYWORD",
  ADD_FULFILLED: "ADD_KEYWORD_FULFILLED",
  ADD_REJECTED: "ADD_KEYWORD_REJECTED",
  EDIT: "EDIT_KEYWORD",
  EDIT_FULFILLED: "EDIT_KEYWORD_FULFILLED",
  EDIT_REJECTED: "EDIT_KEYWORD_REJECTED",
  DELETE: "DELETE_KEYWORD",
  DELETE_FULFILLED: "DELETE_KEYWORD_FULFILLED",
  DELETE_REJECTED: "DELETE_KEYWORD_REJECTED",
  FETCH_DETAILS: "FETCH_KEYWORD_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_KEYWORD_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_KEYWORD_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_KEYWORD_DETAILS",
  FETCH_ALL: "FETCH_ALL_KEYWORDS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_KEYWORDS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_KEYWORDS_REJECTED",
  FETCH_ALL_FOR_PROJECT: "FETCH_ALL_PROJECT_KEYWORDS",
  FETCH_ALL_FOR_PROJECT_FULFILLED: "FETCH_ALL_PROJECT_KEYWORDS_FULFILLED",
  FETCH_ALL_FOR_PROJECT_REJECTED: "FETCH_ALL_PROJECT_KEYWORDS_REJECTED",
};

// Reports actions
export const REPORT = {
  CREATE: "CREATE_REPORT",
  CREATE_FULFILLED: "CREATE_REPORT_FULFILLED",
  CREATE_REJECTED: "CREATE_REPORT_REJECTED",
  DOWNLOAD: "DOWNLOAD_REPORT_DATA",
  DOWNLOAD_FULFILLED: "DOWNLOAD_REPORT_DATA_FULFILLED",
  DOWNLOAD_REJECTED: "DOWNLOAD_REPORT_DATA_REJECTED",
  CLOSE: "CLOSE_REPORT",
  CLEAR_ALL_REPORT_DATA: "CLOSE_ALL_REPORT_DATA",
};

export const CEM4601 = {
  REQUEST: "CEM4601_REQUEST",
  REQUEST_FULFILLED: "CEM4601_REQUEST_FULFILLED",
  REQUEST_REJECTED: "CEM4601_REQUEST_REJECTED",
  BATCH_REQUEST: "CEM4601_BATCH_REQUEST",
  BATCH_REQUEST_FULFILLED: "CEM4601_BATCH_REQUEST_FULFILLED",
  BATCH_REQUEST_REJECTED: "CEM4601_BATCH_REQUEST_REJECTED",
  FILE_REQUEST: "CEM4601_FILE_REQUEST",
  FILE_REQUEST_FULFILLED: "CEM4601_FILE_REQUEST_FULFILLED",
  FILE_REQUEST_REJECTED: "CEM4601_FILE_REQUEST_REJECTED",
};

export const CEM4907 = {
  REQUEST: "CEM4907_REQUEST",
  REQUEST_FULFILLED: "CEM4907_REQUEST_FULFILLED",
  REQUEST_REJECTED: "CEM4907_REQUEST_REJECTED",
  BATCH_REQUEST: "CEM4907_BATCH_REQUEST",
  BATCH_REQUEST_FULFILLED: "CEM4907_BATCH_REQUEST_FULFILLED",
  BATCH_REQUEST_REJECTED: "CEM4907_BATCH_REQUEST_REJECTED",
  FILE_REQUEST: "CEM4907_FILE_REQUEST",
  FILE_REQUEST_FULFILLED: "CEM4907_FILE_REQUEST_FULFILLED",
  FILE_REQUEST_REJECTED: "CEM4907_FILE_REQUEST_REJECTED",
};

export const ADR = {
  GENERIC_REQUEST: "GENERIC_ADR_REQUEST",
  GENERIC_REQUEST_FULFILLED: "GENERIC_ADR_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "GENERIC_ADR_REQUEST_REJECTED",
  CREATE: "CREATE_ADR",
  CREATE_FULFILLED: "CREATE_ADR_FULFILLED",
  CREATE_REJECTED: "CREATE_ADR_REJECTED",
  CREATEV2: "CREATE_ADR_V2",
  CREATEV2_FULFILLED: "CREATE_ADR_V2_FULFILLED",
  CREATEv2_REJECTED: "CREATE_ADR_V2_REJECTED",
  COPY_ON_CLIENT: "COPY_ADR_ON_CLIENT",
  COPY_ON_CLIENT_FULFILLED: "COPY_ADR_ON_CLIENT_FULFILLED",
  COPY_ON_CLIENT_REJECTED: "COPY_ADR_ON_CLIENT_REJECTED",
  COPY: "COPY_ADR",
  COPY_FULFILLED: "COPY_ADR_FULFILLED",
  COPY_REJECTED: "COPY_ADR_REJECTED",
  AMEND: "AMEND_ADR",
  AMEND_FULFILLED: "AMEND_ADR_FULFILLED",
  AMEND_REJECTED: "AMEND_ADR_REJECTED",
  FETCH_AMEND_HISTORY: "FETCH_AMEND_HISTORY",
  FETCH_AMEND_HISTORY_FULFILLED: "FETCH_AMEND_HISTORY_FULFILLED",
  FETCH_AMEND_HISTORY_REJECTED: "FETCH_AMEND_HISTORY_REJECTED",
  FETCH_ADR: "FETCH_ADR",
  FETCH_ADR_FULFILLED: "FETCH_ADR_FULFILLED",
  FETCH_ADR_REJECTED: "FETCH_ADR_REJECTED",
  FETCH_IMAGE: "FETCH_ADR_IMAGE",
  FETCH_IMAGE_FULFILLED: "FETCH_ADR_IMAGE_FULFILLED",
  FETCH_IMAGE_REJECTED: "FETCH_ADR_IMAGE_REJECTED",
  INIT_STORE: "INIT_ADR_STORE",
  FETCH_ADR_LIST: "FETCH_ADR_LIST",
  FETCH_ADR_LIST_FULFILLED: "FETCH_ADR_LIST_FULFILLED",
  FETCH_ADR_LIST_REJECTED: "FETCH_ADR_LIST_REJECTED",
  UPDATE_ADR_LIST: "UPDATE_ADR_LIST",
  FETCH_PREVIEW: "FETCH_ADR_PREVIEW",
  FETCH_PREVIEW_FULFILLED: "FETCH_ADR_PREVIEW_FULFILLED",
  FETCH_PREVIEW_REJECTED: "FETCH_ADR_PREVIEW_REJECTED",
  REFRESH_ADR_LIST: "REFRESH_ADR_LIST",
  REFRESH_ADR_LIST_FULFILLED: "REFRESH_ADR_LIST_FULFILLED",
  REFRESH_ADR_LIST_REJECTED: "REFRESH_ADR_LIST_REJECTED",
  SAVE_ADR: "SAVE_ADR",
  SAVE_ADR_FULFILLED: "SAVE_ADR_FULFILLED",
  SAVE_ADR_REJECTED: "SAVE_ADR_REJECTED",
  SUBMIT: "SUBMIT_ADR",
  SUBMIT_FULFILLED: "SUBMIT_ADR_FULFILLED",
  SUBMIT_REJECTED: "SUBMIT_ADR_REJECTED",
  RETRACT_SUBMIT: "RETRACT_ADR_SUBMIT",
  RETRACT_SUBMIT_FULFILLED: "RETRACT_ADR_SUBMIT_FULFILLED",
  RETRACT_SUBMIT_REJECTED: "RETRACT_ADR_SUBMIT_REJECTED",
  GET_NEXT_TO_REVIEW: "GET_NEXT_TO_REVIEW",
  GET_NEXT_TO_REVIEW_FULFILLED: "GET_NEXT_TO_REVIEW_FULFILLED",
  GET_NEXT_TO_REVIEW_REJECTED: "GET_NEXT_TO_REVIEW_REJECTED",
  CLOSE_ADR: "CLOSE_ADR",
  DELETE_ADR: "DELETE_ADR",
  DELETE_ADR_FULFILLED: "DELETE_ADR_FULFILLED",
  DELETE_ADR_REJECTED: "DELETE_ADR_REJECTED",
  REFRESH_LABORLIST: "REFRESH_LABORLIST",
  REFRESH_EQUIPMENTLIST: "REFRESH_EQUIPMENTLIST",
  FETCH_ADR_SEARCH: "FETCH_ADR_SEARCH",
  FETCH_ADR_SEARCH_FULFILLED: "FETCH_ADR_SEARCH_FULFILLED",
  FETCH_ADR_SEARCH_REJECTED: "FETCH_ADR_SEARCH_REJECTED",
  CLOSE_ADR_LIST: "CLOSE_ADR_LIST",
  CLOSE_SEARCH: "CLOSE_ADR_SEARCH",
  FETCH_ALL_ADR_DATES: "FETCH_ALL_ADR_DATES",
  FETCH_ALL_ADR_DATES_FULFILLED: "FETCH_ALL_ADR_DATES_FULFILLED",
  FETCH_ALL_ADR_DATES_REJECTED: "FETCH_ALL_ADR_DATES_REJECTED",
  FETCH_TENT_AGREEMENT: "FETCH_TENT_AGREEMENT",
  FETCH_TENT_AGREEMENT_FULFILLED: "FETCH_TENT_AGREEMENT_FULFILLED",
  FETCH_TENT_AGREEMENT_REJECTED: "FETCH_TENT_AGREEMENT_REJECTED",
  CLEAR_ALL_ADR_DATA: "CLEAR_ALL_ADR_DATA",
  ADR_UPLOAD_ATTACHMENT: "ADR_UPLOAD_ATTACHMENT",
  ADR_UPLOAD_ATTACHMENT_FULFILLED: "ADR_UPLOAD_ATTACHMENT_FULFILLED",
  ADR_UPLOAD_ATTACHMENT_REJECTED: "ADR_UPLOAD_ATTACHMENT_REJECTED",
  ADR_DELETE_ATTACHMENT: "ADR_DELETE_ATTACHMENT",
  ADR_DELETE_ATTACHMENT_FULFILLED: "ADR_DELETE_ATTACHMENT_FULFILLED",
  ADR_DELETE_TEMP_ATTACHMENT_FULFILLED: "ADR_DELETE_TEMP_ATTACHMENT_FULFILLED",
  ADR_DELETE_ATTACHMENT_REJECTED: "ADR_DELETE_ATTACHMENT_REJECTED",
  ADR_ADD_TEMP_FILEPATHS: "ADR_ADD_TEMP_FILEPATHS", // Collects new attachment filepaths in case they need to be deleted
  ADR_CLEAR_TEMP_FILEPATHS: "ADR_CLEAR_TEMP_FILEPATHS",
  DOWNLOAD_ATTACHMENTS: "ADR_DOWNLOAD_ATTACHMENTS",
  DOWNLOAD_ATTACHMENTS_FULFILLED: "DOWNLOAD_ATTACHMENTS_FULFILLED",
  DOWNLOAD_ATTACHMENTS_REJECTED: "DOWNLOAD_ATTACHMENTS_REJECTED",
  UPDATE_STATUS: "UPDATE_ADR_STATUS",
  // Dashboard-related action constants
  FETCH_SUMMARY: "FETCH_ADR_SUMMARY",
  FETCH_SUMMARY_FULFILLED: "FETCH_ADR_SUMMARY_FULFILLED",
  FETCH_SUMMARY_REJECTED: "FETCH_ADR_SUMMARY_REJECTED",
  FETCH_COUNT_OF_SAFETY_COMMENTS: "FETCH_COUNT_OF_SAFETY_COMMENTS",
  FETCH_COUNT_OF_SAFETY_COMMENTS_FULFILLED: "FETCH_COUNT_OF_SAFETY_COMMENTS_FULFILLED",
  FETCH_COUNT_OF_SAFETY_COMMENTS_REJECTED: "FETCH_COUNT_OF_SAFETY_COMMENTS_REJECTED",
  FETCH_CORRECTION_COMMENTS: "FETCH_ADR_CORRECTION_COMMENTS",
  FETCH_CORRECTION_COMMENTS_FULFILLED: "FETCH_ADR_CORRECTION_COMMENTS_FULFILLED",
  FETCH_CORRECTION_COMMENTS_REJECTED: "FETCH_ADR_CORRECTION_COMMENTS_REJECTED",
  FETCH_CLARIFICATION_COMMENTS: "FETCH_ADR_CLARIFICATION_COMMENTS",
  FETCH_CLARIFICATION_COMMENTS_FULFILLED: "FETCH_ADR_CLARIFICATION_COMMENTS_FULFILLED",
  FETCH_CLARIFICATION_COMMENTS_REJECTED: "FETCH_ADR_CLARIFICATION_COMMENTS_REJECTED",
};

export const ADR_EDIT = {
  STATUS: "ADR_STATUS",
  HEADER: {
    UPDATE: "ADR_HEADER_UPDATE",
  },
  WORKPERFORMED: {
    INIT_CLIENT: "ADR_WORKPERFORMED_INIT_CLIENT",
    ADD: "ADR_WORKPERFORMED_ADD",
    DELETE: "ADR_WORKPERFORMED_DELETE",
    DELETE_FULFILLED: "ADR_WORKPERFORMED_DELETE_FULFILLED",
    DELETE_REJECTED: "ADR_WORKPERFORMED_DELETE_REJECTED",
    REORDER: "ADR_WORKPERFORMED_REORDER",
  },
  LOCATION_WORKPERFORMED: {
    ADD: "ADR_LOCATION_WORKPERFORMED_ADD",
    DELETE: "ADR_LOCATION_WORKPERFORMED_DELETE",
    REORDER: "ADR_LOCATION_WORKPERFORMED_REORDER",
    UPDATE: "ADR_LOCATION_WORKPERFORMED_UPDATE",
    MISC_MATERIALS: {
      ADD: "ADR_LOCATION_WORKPERFORMED_MISC_MATERIALS_ADD",
      DELETE: "ADR_LOCATION_WORKPERFORMED_MISC_MATERIALS_DELETE",
      UPDATE: "ADR_LOCATION_WORKPERFORMED_MISC_MATERIALS_UPDATE",
    },
    TESTS_PERFORMED: {
      ADD: "ADR_LOCATION_WORKPERFORMED_TEST_ADD",
      DELETE: "ADR_LOCATION_WORKPERFORMED_TEST_DELETE",
      UPDATE: "ADR_LOCATION_WORKPERFORMED_TEST_UPDATE",
    },
    ATTACHMENTS: {
      ADD: "ADR_LOCATION_WORKPERFORMED_ATTACHMENT_ADD",
      TOGGLE_DELETE: "ADR_LOCATION_WORKPERFORMED_ATTACHMENT_TOGGLE_DELETE",
      UPDATE: "ADR_LOCATION_WORKPERFORMED_ATTACHMENT_UPDATE",
    },
  },
  LABORSET: {
    ADD: "ADR_LABORSET_ADD",
    DELETE: "ADR_LABORSET_DELETE",
    REORDER: "ADR_LABORSET_REORDER",
    UPDATE: "ADR_LABORSET_UPDATE",
    APPLY_HOURS_FROM_TA: "ADR_LABORSET_APPLY_HOURS_FROM_TA",
    SHOW_ALL_OT: "ADR_LABORSET_SHOW_ALL_OT",
    HIDE_ALL_OT: "ADR_LABORSET_HIDE_ALL_OT",
    HOURS: {
      UPDATE: "ADR_LABORSET_HOURS_UPDATE",
    },
    REMARKS: {
      UPDATE: "ADR_LABORSET_REMARKS_UPDATE",
    },
  },
  EQUIPMENTSET: {
    ADD: "ADR_EQUIPSET_ADD",
    DELETE: "ADR_EQUIPSET_DELETE",
    REORDER: "ADR_EQUIPSET_REORDER",
    UPDATE: "ADR_EQUIPSET_UPDATE",
    APPLY_HOURS_FROM_TA: "ADR_EQUIPSET_APPLY_HOURS_FROM_TA",
    SHOW_ALL_OT: "ADR_EQUIPSET_SHOW_ALL_OT",
    HIDE_ALL_OT: "ADR_EQUIPSET_HIDE_ALL_OT",
    HOURS: {
      UPDATE: "ADR_EQUIPSET_HOURS_UPDATE",
    },
    OPERATOR: {
      UPDATE: "ADR_EQUIPSET_OPERATOR_UPDATE",
    },
    REMARKS: {
      UPDATE: "ADR_EQUIPSET_REMARKS_UPDATE",
    },
  },
  GENERAL_COMMENTS: {
    ADD: "ADR_GENERAL_COMMENT_ADD",
    DELETE: "ADR_GENERAL_COMMENT_DELETE",
    UPDATE: "ADR_GENERAL_COMMENT_UPDATE",
    REORDER: "ADR_GENERAL_COMMENT_REORDER",
    KEYWORDS: {
      UPDATE: "ADR_GENERAL_COMMENT_KEYWORD_UPDATE",
    },
    ATTACHMENTS: {
      ADD: "ADR_GENERAL_COMMENT_ATTACHMENT_ADD",
      TOGGLE_DELETE: "ADR_GENERAL_COMMENT_ATTACHMENT_TOGGLE_DELETE",
      UPDATE: "ADR_GENERAL_COMMENT_ATTACHMENT_UPDATE",
    },
  },
  TENTATIVE_AGREEMENTS: {
    ADD_BLANK: "TENTATIVE_AGREEMENT_ADD_BLANK",
    DELETE: "TENTATIVE_AGREEMENT_DELETE",
    UPDATE: "TENTATIVE_AGREEMENT_UPDATE",
    SAVE: "TENTATIVE_AGREEMENT_SAVE",
    WORKPERFORMED: {
      ADD: "TENTATIVE_AGREEMENT_WP_ADD",
      DELETE: "TENTATIVE_AGREEMENT_WP_DELETE",
    },
    CONTRACTORS: {
      ADD: "TENTATIVE_AGREEMENT_CTR_ADD",
      DELETE: "TENTATIVE_AGREEMENT_CTR_DELETE",
      UPDATE: "TENTATIVE_AGREEMENT_CTR_UPDATE",
    },
    ADD_TEMP_FILEPATHS: "TENTATIVE_AGREEMENT_ADD_TEMP_FILEPATHS",
    CLEAR_TEMP_FILEPATHS: "TENTATIVE_AGREEMENT_CLEAR_TEMP_FILEPATHS",
    SEND_EMAIL: "TENTATIVE_AGREEMENT_SEND_EMAIL",
    SEND_EMAIL_FULFILLED: "TENTATIVE_AGREEMENT_SEND_EMAIL_FULFILLED",
    SEND_EMAIL_REJECTED: "TENTATIVE_AGREEMENT_SEND_EMAIL_REJECTED",
  },
};

export const ADR_REVIEW = {
  START: "START_ADR_REVIEW",
  START_FULFILLED: "START_ADR_REVIEW_FULFILLED",
  START_REJECTED: "START_ADR_REVIEW_REJECTED",
  TRANSFER: "TRANSFER_ADR_REVIEW",
  TRANSFER_FULFILLED: "TRANSFER_ADR_REVIEW_FULFILLED",
  TRANSFER_REJECTED: "TRANSFER_ADR_REVIEW_REJECTED",
  REVOKE: "REVOKE_ADR_REVIEW",
  REJECT: "REJECT_ADR",
  REJECT_FULFILLED: "REJECT_ADR_FULFILLED",
  REJECT_REJECTED: "REJECT_ADR_REJECTED",
  APPROVE: "APPROVE_ADR",
  APPROVE_FULFILLED: "APPROVE_ADR_FULFILLED",
  APPROVE_REJECTED: "APPROVE_ADR_REJECTED",
  SAVE: "SAVE_ADR_REVIEW",
  SAVE_FULFILLED: "SAVE_ADR_REVIEW_FULFILLED",
  SAVE_REJECTED: "SAVE_ADR_REVIEW_REJECTED",
  SET_REVIEWER_USERID: "SET_REVIEWER_USERID",
  CORRECTION_COMMENTS: {
    ADD_BLANK: "ADR_CORRECTION_COMMENT_ADD_BLANK",
    DELETE: "ADR_CORRECTION_COMMENT_DELETE",
    UPDATE: "ADR_CORRECTION_COMMENT_UPDATE",
  },
  CLARIFICATION_COMMENTS: {
    ADD_BLANK: "ADR_CLARIFICATION_COMMENT_ADD_BLANK",
    DELETE: "ADR_CLARIFICATION_COMMENT_DELETE",
    UPDATE: "ADR_CLARIFICATION_COMMENT_UPDATE",
    KEYWORDS: {
      UPDATE: "ADR_CLARIFICATION_COMMENT_KEYWORD_UPDATE",
    },
  },
};

export const UNIT = {
  ADD: "ADD_UNIT",
  ADD_FULFILLED: "ADD_UNIT_FULFILLED",
  ADD_REJECTED: "ADD_UNIT_REJECTED",
  EDIT: "EDIT_UNIT",
  EDIT_FULFILLED: "EDIT_UNIT_FULFILLED",
  EDIT_REJECTED: "EDIT_UNIT_REJECTED",
  FETCH_DETAILS: "FETCH_UNIT_DETAILS",
  FETCH_DETAILS_FULFILLED: "FETCH_UNIT_DETAILS_FULFILLED",
  FETCH_DETAILS_REJECTED: "FETCH_UNIT_DETAILS_REJECTED",
  CLEAR_DETAILS: "CLEAR_UNIT_DETAILS",
  FETCH_ALL: "FETCH_ALL_UNITS",
  FETCH_ALL_FULFILLED: "FETCH_ALL_UNITS_FULFILLED",
  FETCH_ALL_REJECTED: "FETCH_ALL_UNITS_REJECTED",
};

// Users actions
export const USER = {
  GENERIC_REQUEST: "USER_GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "USER_GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "USER_GENERIC_REQUEST_REJECTED",
  REGISTER_USER: "REGISTER_USER",
  REGISTER_USER_FULFILLED: "REGISTER_USER_FULFILLED",
  REGISTER_USER_REJECTED: "REGISTER_USER_REJECTED",
  EDIT_USER: "EDIT_USER",
  EDIT_USER_FULFILLED: "EDIT_USER_FULFILLED",
  EDIT_USER_REJECTED: "EDIT_USER_REJECTED",
  EDIT_USER_SELF: "EDIT_USER_SELF",
  VERIFY_TOKEN: "VERIFY_TOKEN",
  FETCH_EMPLOYEE: "FETCH_EMPLOYEE",
  FETCH_EMPLOYEE_FULFILLED: "FETCH_EMPLOYEE_FULFILLED",
  FETCH_EMPLOYEE_REJECTED: "FETCH_EMPLOYEE_REJECTED",
  FETCH_ALL_EMPLOYEES: "FETCH_ALL_EMPLOYEES",
  FETCH_ALL_EMPLOYEES_FULFILLED: "FETCH_ALL_EMPLOYEES_FULFILLED",
  FETCH_ALL_EMPLOYEES_REJECTED: "FETCH_ALL_EMPLOYEES_REJECTED",
  CLEAR_EMPLOYEES_LIST: "CLEAR_EMPLOYEES_LIST",
  CLEAR_USER_LIST: "CLEAR_USER_LIST",
  CLEAR_USER_LIST_V2: "CLEAR_USER_LIST_V2",
  CLEAR_USER_DETAILS: "CLEAR_USER_DETAILS",
  CLEAR_MISC_SESSION_DATA: "CLEAR_MISC_SESSION_DATA",
  EMPLOYEE_EXISTS: "EMPLOYEE_EXISTS",
  EMPLOYEE_EXISTS_FULFILLED: "EMPLOYEE_EXISTS_FULFILLED",
  EMPLOYEE_EXISTS_REJECTED: "EMPLOYEE_EXISTS_REJECTED",
  SET_EMPLOYEE_SEARCH_WAITINGFOR: "SET_EMPLOYEE_SEARCH_WAITINGFOR",
  FETCH_EMPLOYEE_SUGGESTIONS: "FETCH_EMPLOYEE_SUGGESTIONS",
  FETCH_EMPLOYEE_SUGGESTIONS_FULFILLED: "FETCH_EMPLOYEE_SUGGESTIONS_FULFILLED",
  FETCH_EMPLOYEE_SUGGESTIONS_REJECTED: "FETCH_EMPLOYEE_SUGGESTIONS_REJECTED",
  UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",
  FETCH_NAME: "FETCH_NAME",
  FETCH_NAME_FULFILLED: "FETCH_NAME_FULFILLED",
  FETCH_NAME_REJECTED: "FETCH_NAME_REJECTED",
  FETCH_USER: "FETCH_USER",
  FETCH_USER_FULFILLED: "FETCH_USER_FULFILLED",
  FETCH_USER_REJECTED: "FETCH_USER_REJECTED",
  FETCH_SIGNATURE: "FETCH_USER_SIGNATURE",
  FETCH_SIGNATURE_FULFILLED: "FETCH_USER_SIGNATURE_FULFILLED",
  FETCH_SIGNATURE_REJECTED: "FETCH_USER_SIGNATURE_REJECTED",
  ADD_SIGNATURE: "ADD_USER_SIGNATURE",
  ADD_SIGNATURE_FULFILLED: "ADD_USER_SIGNATURE_FULFILLED",
  ADD_SIGNATURE_REJECTED: "ADD_USER_SIGNATURE_REJECTED",
  UPDATE_SIGNATURE: "UPDATE_USER_SIGNATURE",
  UPDATE_SIGNATURE_FULFILLED: "UPDATE_USER_SIGNATURE_FULFILLED",
  UPDATE_SIGNATURE_REJECTED: "UPDATE_USER_SIGNATURE_REJECTED",
  DELETE_SIGNATURE: "DELETE_USER_SIGNATURE",
  DELETE_SIGNATURE_FULFILLED: "DELETE_USER_SIGNATURE_FULFILLED",
  DELETE_SIGNATURE_REJECTED: "DELETE_USER_SIGNATURE_REJECTED",
  // Signature is stored as DataURL and can be quite large (>10kb for one).
  // Clear signature data from redux store whenever it is no longer needed.
  CLEAR_SIGNATURE_DATA: "CLEAR_USER_SIGNATURE_DATA",
  FETCH_ALL_USERS: "FETCH_ALL_USERS",
  FETCH_ALL_USERS_FULFILLED: "FETCH_ALL_USERS_FULFILLED",
  FETCH_ALL_USERS_REJECTED: "FETCH_ALL_USERS_REJECTED",
  FETCH_ALL_USERS_PAGED_FULFILLED: "FETCH_ALL_USERS_PAGED_FULFILLED",
  FETCH_ALL_USERS_PAGED_REJECTED: "FETCH_ALL_USERS_PAGED_REJECTED",
  FETCH_ALL_USERS_PAGED_FULFILLED_V2: "FETCH_ALL_USERS_PAGED_FULFILLED_V2",
  FETCH_ALL_USERS_PAGED_REJECTED_V2: "FETCH_ALL_USERS_PAGED_REJECTED_V2",
  REFRESH_ALL_USERS_V2: "REFRESH_ALL_USERS_V2",
  REFRESH_ALL_USERS_V2_FULFILLED: "REFRESH_ALL_USERS_V2_FULFILLED",
  REFRESH_ALL_USERS_V2_REJECTED: "REFRESH_ALL_USERS_V2_REJECTED",
  UPDATE_LIST_FILTER: "UPDATE_LIST_FILTER",
  SET_USER_SEARCH_WAITINGFOR: "SET_USER_SEARCH_WAITINGFOR",
  FETCH_USER_SUGGESTIONS: "FETCH_USER_SUGGESTIONS",
  FETCH_USER_SUGGESTIONS_FULFILLED: "FETCH_USER_SUGGESTIONS_FULFILLED",
  FETCH_USER_SUGGESTIONS_REJECTED: "FETCH_USER_SUGGESTIONS_REJECTED",
  FETCH_ALL_MANAGERS: "FETCH_ALL_MANAGERS",
  FETCH_ALL_MANAGERS_FULFILLED: "FETCH_ALL_MANAGERS_FULFILLED",
  FETCH_ALL_MANAGERS_REJECTED: "FETCH_ALL_MANAGERS_REJECTED",
  FETCH_PROJECT_ROLES: "FETCH_USER_PROJECT_ROLES",
  FETCH_PROJECT_ROLES_FULFILLED: "FETCH_USER_PROJECT_ROLES_FULFILLED",
  FETCH_PROJECT_ROLES_REJECTED: "FETCH_USER_PROJECT_ROLES_REJECTED",
  DELETE_USER: "DELETE_USER",
  DELETE_USER_FULFILLED: "DELETE_USER_FULFILLED",
  DELETE_USER_REJECTED: "DELETE_USER_REJECTED",
  FETCH_USER_ROLES: "FETCH_USER_ROLES",
  FETCH_USER_ROLES_FULFILLED: "FETCH_USER_ROLES_FULFILLED",
  FETCH_USER_ROLES_REJECTED: "FETCH_USER_ROLES_REJECTED",
  CLEAR_ALL_USER_DATA: "CLEAR_ALL_USER_DATA",
};

export const USER_PREFERENCES = {
  GENERIC_REQUEST: "USER_PREFERENCES_GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "USER_PREFERENCES_GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "USER_PREFERENCES_GENERIC_REQUEST_REJECTED",
  FETCH: "FETCH_USER_PREFERENCES",
  FETCH_REJECTED: "FETCH_USER_PREFERENCES_REJECTED",
  FETCH_FULFILLED: "FETCH_USER_PREFERENCES_FULFILLED",
  FETCH_PROFILE_PIC: "FETCH_USER_PROFILE_PIC",
  FETCH_PROFILE_PIC_FULFILLED: "FETCH_USER_PROFILE_PIC_FULFILLED",
  FETCH_PROFILE_PIC_REJECTED: "FETCH_USER_PROFILE_PIC_REJECTED",
  // For updating local redux store only; use SAVE for database save
  UPDATE: "UPDATE_USER_PREFERENCES",
  RESET_TO_DEFAULTS: "USERPREFS_RESET",
  DELETE_PROFILE_PIC: "DELETE_USER_PROFILE_PIC",
  SAVE: "SAVE_USER_PREFERENCES",
  SAVE_FULFILLED: "SAVE_USER_PREFERENCES_FULFILLED",
  SAVE_REJECTED: "SAVE_USER_PREFERENCES_REJECTED",
  CLEAR_MISC_SESSION_DATA: "CLEAR_USER_PREFERENCES_SESSION_DATA",
};

export const overtime = {
  FETCH_USER_OVERTIMES: "FETCH_USER_OVERTIMES",
  FETCH_USER_OVERTIMES_FULFILLED: "FETCH_USER_OVERTIMES_FULFILLED",
  FETCH_USER_OVERTIMES_REJECTED: "FETCH_USER_OVERTIMES_REJECTED",
  REQUEST_OVERTIME: "REQUEST_OVERTIME",
  REQUEST_OVERTIME_FULFILLED: "REQUEST_OVERTIME_FULFILLED",
  REQUEST_OVERTIME_REJECTED: "REQUEST_OVERTIME_REJECTED",
  EDIT_OVERTIME: "EDIT_OVERTIME",
  EDIT_OVERTIME_FULFILLED: "EDIT_OVERTIME_FULFILLED",
  EDIT_OVERTIME_REJECTED: "EDIT_OVERTIME_REJECTED",
};

export const fieldOfficeActions = {
  FETCH_FIELD_OFFICES: "FETCH_FIELD_OFFICES",
  FETCH_FIELD_OFFICES_FULFILLED: "FETCH_FIELD_OFFICES_FULFILLED",
  FETCH_FIELD_OFFICES_REJECTED: "FETCH_FIELD_OFFICES_REJECTED",
  ADD_FIELD_OFFICE: "ADD_FIELD_OFFICE",
  ADD_FIELD_OFFICE_FULFILLED: "ADD_FIELD_OFFICE_FULFILLED",
  ADD_FIELD_OFFICE_REJECTED: "ADD_FIELD_OFFICE_REJECTED",
  EDIT_FIELD_OFFICE: "EDIT_FIELD_OFFICE",
  EDIT_FIELD_OFFICE_FULFILLED: "EDIT_FIELD_OFFICE_FULFILLED",
  EDIT_FIELD_OFFICE_REJECTED: "EDIT_FIELD_OFFICE_REJECTED",
  DELETE_FIELD_OFFICE: "DELETE_FIELD_OFFICE",
  DELETE_FIELD_OFFICE_FULFILLED: "DELETE_FIELD_OFFICE_FULFILLED",
  DELETE_FIELD_OFFICE_REJECTED: "DELETE_FIELD_OFFICE_REJECTED",
};

export const APP_SETTINGS = {
  GET_APP_SETTINGS: "GET_APP_SETTINGS",
  GET_APP_SETTINGS_FULFILLED: "GET_APP_SETTINGS_FULFILLED",
  GET_APP_SETTINGS_REJECTED: "GET_APP_SETTINGS_REJECTED",
  CLEAR_APP_SETTINGS: "CLEAR_APP_SETTINGS",
};

export const AUTH = {
  LOGIN_REQUEST: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  GET_AUTHORIZATION: "GET_AUTHORIZATION",
  GET_AUTHORIZATION_FULFILLED: "GET_AUTHORIZATION_FULFILLED",
  GET_AUTHORIZATION_REJECTED: "GET_AUTHORIZATION_REJECTED",
  LOGOUT: "LOGOUT",
};

export const ISSUE = {
  ADD_ISSUE: "ADD_ISSUE",
  ADD_ISSUE_FULFILLED: "ADD_ISSUE_FULFILLED",
  ADD_ISSUE_REJECTED: "ADD_ISSUE_REJECTED",
  FETCH_ISSUE: "FETCH_ISSUE",
  FETCH_ISSUE_FULFILLED: "FETCH_ISSUE_FULFILLED",
  FETCH_ISSUE_REJECTED: "FETCH_ISSUE_REJECTED",
  FOLLOW_ISSUE: "FOLLOW_ISSUE",
  FOLLOW_ISSUE_FULFILLED: "FOLLOW_ISSUE_FULFILLED",
  FOLLOW_ISSUE_REJECTED: "FOLLOW_ISSUE_REJECTED",
  UNFOLLOW_ISSUE: "UNFOLLOW_ISSUE",
  UNFOLLOW_ISSUE_FULFILLED: "UNFOLLOW_ISSUE_FULFILLED",
  UNFOLLOW_ISSUE_REJECTED: "UNFOLLOW_ISSUE_REJECTED",
  FETCH_ALL_ISSUES: "FETCH_ALL_ISSUES",
  FETCH_ALL_ISSUES_FULFILLED: "FETCH_ALL_ISSUES_FULFILLED",
  FETCH_ALL_ISSUES_REJECTED: "FETCH_ALL_ISSUES_REJECTED",
  UPDATE_ISSUE: "UPDATE_ISSUE",
  UPDATE_ISSUE_FULFILLED: "UPDATE_ISSUE_FULFILLED",
  UPDATE_ISSUE_REJECTED: "UPDATE_ISSUE_REJECTED",
  ADD_POST: "ADD_POST",
  ADD_POST_FULFILLED: "ADD_POST_FULFILLED",
  ADD_POST_REJECTED: "ADD_POST_REJECTED",
  LIKE_POST: "LIKE_POST",
  LIKE_POST_FULFILLED: "LIKE_POST_FULFILLED",
  LIKE_POST_REJECTED: "LIKE_POST_REJECTED",
  UNLIKE_POST: "UNLIKE_POST",
  UNLIKE_POST_FULFILLED: "UNLIKE_POST_FULFILLED",
  UNLIKE_POST_REJECTED: "UNLIKE_POST",
  CLOSE_ISSUE_TAB: "CLOSE_ISSUE_TAB",
};

export const PROJDASH = {
  FETCH_WIDGET_APIDATA: "FETCH_PROJDASH_WIDGET_APIDATA",
  FETCH_WIDGET_APIDATA_FULFILLED: "FETCH_PROJDASH_WIDGET_APIDATA_FULFILLED",
  FETCH_WIDGET_APIDATA_REJECTED: "FETCH_PROJDASH_WIDGET_APIDATA_REJECTED",
  LOAD_WIDGETS: "LOAD_PROJDASH_WIDGETS",
  LOAD_WIDGETS_FULFILLED: "LOAD_PROJDASH_WIDGETS_FULFILLED",
  LOAD_WIDGETS_REJECTED: "LOAD_WIDGETS_REJECTED",
  UPDATE_WIDGET: "UPDATE_PROJDASH_WIDGET",
  UPDATE_WIDGET_FULFILLED: "UPDATE_PROJDASH_WIDGET_FULFILLED",
  UPDATE_WIDGET_REJECTED: "UPDATE_PROJDASH_WIDGET_REJECTED",
};

export const QMS = {
  GENERIC_REQUEST: "QMS.GENERIC_REQUEST",
  GENERIC_REQUEST_FULFILLED: "QMS.GENERIC_REQUEST_FULFILLED",
  GENERIC_REQUEST_REJECTED: "QMS.GENERIC_REQUEST_REJECTED",
  FILE_REQUEST: "QMS.FILE_REQUEST",
  FILE_REQUEST_FULFILLED: "QMS.FILE_REQUEST_FULFILLED",
  FILE_REQUEST_REJECTED: "QMS.FILE_REQUEST_REJECTED",
  PERMISSIONS: {
    FETCH_FOR_USER: "QMS.PERMISSIONS.FETCH_FOR_USER",
    FETCH_FOR_USER_FULFILLED: "QMS.PERMISSIONS.FETCH_FOR_USER_FULFILLED",
    FETCH_FOR_USER_REJECTED: "QMS.PERMISSIONS.FETCH_FOR_USER_REJECTED",
    FETCH_PERMISSION_SCOPES_ACTIONS: "QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS",
    FETCH_PERMISSION_SCOPES_ACTIONS_FULFILLED:
      "QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS_FULFILLED",
    FETCH_PERMISSION_SCOPES_ACTIONS_REJECTED:
      "QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS_REJECTED",
  },
  DIVISIONS: {
    FETCH_ALL: "QMS.DIVISIONS.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.DIVISIONS.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.DIVISIONS.FETCH_ALL_REJECTED",
    ADD: "QMS.DIVISIONS.ADD",
    ADD_FULFILLED: "QMS.DIVISIONS.ADD_FULFILLED",
    ADD_REJECTED: "QMS.DIVISIONS.ADD_REJECTED",
    REMOVE: "QMS.DIVISIONS.REMOVE",
    REMOVE_FULFILLED: "QMS.DIVISIONS.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.DIVISIONS.REMOVE_REJECTED",
    UPDATE: "QMS.DIVISIONS.UPDATE",
    UPDATE_FULFILLED: "QMS.DIVISIONS.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.DIVISIONS.UPDATE_REJECTED",
  },
  CMT_STAGE: {
    FETCH: "QMS.CMT_STAGE.FETCH",
    FETCH_FULFILLED: "QMS.CMT_STAGE.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.CMT_STAGE.FETCH_REJECTED",
    FETCH_ALL: "QMS.CMT_STAGE.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.CMT_STAGE.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.CMT_STAGE.FETCH_ALL_REJECTED",
    ADD: "QMS.CMT_STAGE.ADD",
    ADD_FULFILLED: "QMS.CMT_STAGE.ADD_FULFILLED",
    ADD_REJECTED: "QMS.CMT_STAGE.ADD_REJECTED",
    REMOVE: "QMS.CMT_STAGE.REMOVE",
    REMOVE_FULFILLED: "QMS.CMT_STAGE.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.CMT_STAGE.REMOVE_REJECTED",
    UPDATE: "QMS.CMT_STAGE.UPDATE",
    UPDATE_FULFILLED: "QMS.CMT_STAGE.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.CMT_STAGE.UPDATE_REJECTED",
  },
  WORKFLOW: {
    FETCH: "QMS.WORKFLOW.FETCH",
    FETCH_FULFILLED: "QMS.WORKFLOW.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.WORKFLOW.FETCH_REJECTED",
    FETCH_ALL: "QMS.WORKFLOW.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.WORKFLOW.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.WORKFLOW.FETCH_ALL_REJECTED",
    ADD: "QMS.WORKFLOW.ADD",
    ADD_FULFILLED: "QMS.WORKFLOW.ADD_FULFILLED",
    ADD_REJECTED: "QMS.WORKFLOW.ADD_REJECTED",
    EDIT: "QMS.WORKFLOW.EDIT",
    REMOVE: "QMS.WORKFLOW.REMOVE",
    REMOVE_FULFILLED: "QMS.WORKFLOW.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.WORKFLOW.REMOVE_REJECTED",
    FETCH_RELTYPES: "QMS.WORKFLOW.FETCH_RELTYPES",
    FETCH_RELTYPES_FULFILLED: "QMS.WORKFLOW.FETCH_RELTYPES_FULFILLED",
    FETCH_RELTYPES_REJECTED: "QMS.WORKFLOW.FETCH_RELTYPES_REJECTED",
    CLEAR: "QMS.WORKFLOW.CLEAR",
    UPDATE: "QMS.WORKFLOW.UPDATE",
    UPDATE_FULFILLED: "QMS.WORKFLOW.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.WORKFLOW.UPDATE_REJECTED",
  },
  CMT_CATEGORY: {
    FETCH: "QMS.CMT_CATEGORY.FETCH",
    FETCH_FULFILLED: "QMS.CMT_CATEGORY.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.CMT_CATEGORY.FETCH_REJECTED",
    FETCH_ALL: "QMS.CMT_CATEGORY.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.CMT_CATEGORY.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.CMT_CATEGORY.FETCH_ALL_REJECTED",
    ADD: "QMS.CMT_CATEGORY.ADD",
    ADD_FULFILLED: "QMS.CMT_CATEGORY.ADD_FULFILLED",
    ADD_REJECTED: "QMS.CMT_CATEGORY.ADD_REJECTED",
    REMOVE: "QMS.CMT_CATEGORY.REMOVE",
    REMOVE_FULFILLED: "QMS.CMT_CATEGORY.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.CMT_CATEGORY.REMOVE_REJECTED",
    UPDATE: "QMS.CMT_CATEGORY.UPDATE",
    UPDATE_FULFILLED: "QMS.CMT_CATEGORY.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.CMT_CATEGORY.UPDATE_REJECTED",
  },
  CMT_QMSFC: {
    FETCH_ALL: "QMS.CMT_QMSFC.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.CMT_QMSFC.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.CMT_QMSFC.FETCH_ALL_REJECTED",
    ADD: "QMS.CMT_QMSFC.ADD",
    ADD_FULFILLED: "QMS.CMT_QMSFC.ADD_FULFILLED",
    ADD_REJECTED: "QMS.CMT_QMSFC.ADD_REJECTED",
    REMOVE: "QMS.CMT_QMSFC.REMOVE",
    REMOVE_FULFILLED: "QMS.CMT_QMSFC.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.CMT_QMSFC.REMOVE_REJECTED",
    UPDATE: "QMS.CMT_QMSFC.UPDATE",
    UPDATE_FULFILLED: "QMS.CMT_QMSFC.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.CMT_QMSFC.UPDATE_REJECTED",
  },
  TEAM: {
    FETCH: "QMS.TEAM.FETCH",
    FETCH_FULFILLED: "QMS.TEAM.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.TEAM.FETCH_REJECTED",
    FETCH_ALL: "QMS.TEAM.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.TEAM.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.TEAM.FETCH_ALL_REJECTED",
    FETCH_MEMBERS: "QMS.TEAM.FETCH_MEMBERS",
    FETCH_MEMBERS_FULFILLED: "QMS.TEAM.FETCH_MEMBERS_FULFILLED",
    FETCH_MEMBERS_REJECTED: "QMS.TEAM.FETCH_MEMBERS_REJECTED",
    ADD: "QMS.TEAM.ADD",
    ADD_FULFILLED: "QMS.TEAM.ADD_FULFILLED",
    ADD_REJECTED: "QMS.TEAM.ADD_REJECTED",
    REMOVE: "QMS.TEAM.REMOVE",
    REMOVE_FULFILLED: "QMS.TEAM.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.TEAM.REMOVE_REJECTED",
    UPDATE: "QMS.TEAM.UPDATE",
    UPDATE_FULFILLED: "QMS.TEAM.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.TEAM.UPDATE_REJECTED",
  },
  DOCUMENTS: {
    FETCH: "QMS.DOCUMENTS.FETCH",
    FETCH_FULFILLED: "QMS.DOCUMENTS.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.DOCUMENTS.FETCH_REJECTED",
    FETCH_ALL: "QMS.DOCUMENTS.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.DOCUMENTS.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.DOCUMENTS.FETCH_ALL_REJECTED",
    ADD: "QMS.DOCUMENTS.ADD",
    ADD_FULFILLED: "QMS.DOCUMENTS.ADD_FULFILLED",
    ADD_REJECTED: "QMS.DOCUMENTS.ADD_REJECTED",
    REMOVE: "QMS.DOCUMENTS.REMOVE",
    REMOVE_FULFILLED: "QMS.DOCUMENTS.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.DOCUMENTS.REMOVE_REJECTED",
    UPDATE: "QMS.DOCUMENTS.UPDATE",
    UPDATE_FULFILLED: "QMS.DOCUMENTS.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.DOCUMENTS.UPDATE_REJECTED",
  },
  DOCUMENTTYPES: {
    FETCH_ALL: "QMS.DOCUMENTTYPES.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.DOCUMENTTYPES.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.DOCUMENTTYPES.FETCH_ALL_REJECTED",
    ADD: "QMS.DOCUMENTTYPES.ADD",
    ADD_FULFILLED: "QMS.DOCUMENTTYPES.ADD_FULFILLED",
    ADD_REJECTED: "QMS.DOCUMENTTYPES.ADD_REJECTED",
    REMOVE: "QMS.DOCUMENTTYPES.REMOVE",
    REMOVE_FULFILLED: "QMS.DOCUMENTTYPES.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.DOCUMENTTYPES.REMOVE_REJECTED",
    UPDATE: "QMS.DOCUMENTTYPES.UPDATE",
    UPDATE_FULFILLED: "QMS.DOCUMENTTYPES.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.DOCUMENTTYPES.UPDATE_REJECTED",
  },
  USER: {
    CLEAR: "QMS.USER.CLEAR",
    FETCH: "QMS.USER.FETCH",
    FETCH_FULFILLED: "QMS.USER.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.USER.FETCH_REJECTED",
    FETCH_ALL: "QMS.USER.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.USER.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.USER.FETCH_ALL_REJECTED",
    FETCH_ALL_FOR_ISSUE: "QMS.USER.FETCH_ALL_FOR_ISSUE",
    FETCH_ALL_FOR_ISSUE_FULFILLED: "QMS.USER.FETCH_ALL_FOR_ISSUE_FULFILLED",
    FETCH_ALL_FOR_ISSUE_REJECTED: "QMS.USER.FETCH_ALL_FOR_ISSUE_REJECTED",
    FETCH_ROLES: "QMS.USER.FETCH_ROLES",
    FETCH_ROLES_FULFILLED: "QMS.USER.FETCH_ROLES_FULFILLED",
    FETCH_ROLES_REJECTED: "QMS.USER.FETCH_ROLES_REJECTED",
    FETCH_FUNCTIONAL_ROLES: "QMS.USER.FETCH_FUNCTIONAL_ROLES",
    FETCH_FUNCTIONAL_ROLES_FULFILLED: "QMS.USER.FETCH_FUNCTIONAL_ROLES_FULFILLED",
    FETCH_FUNCTIONAL_ROLES_REJECTED: "QMS.USER.FETCH_FUNCTIONAL_ROLES_REJECTED",
    UPDATE_CLIENT: "QMS.USER.UPDATE_CLIENT",
    ADD: "QMS.USER.ADD",
    ADD_FULFILLED: "QMS.USER.ADD_FULFILLED",
    ADD_REJECTED: "QMS.USER.ADD_REJECTED",
    REMOVE: "QMS.USER.REMOVE",
    REMOVE_FULFILLED: "QMS.USER.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.USER.REMOVE_REJECTED",
    UPDATE: "QMS.USER.UPDATE",
    UPDATE_FULFILLED: "QMS.USER.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.USER.UPDATE_REJECTED",
  },
  TEAM_MEMBER_ROLE: {
    FETCH_ALL: "QMS.TEAM_MEMBER_ROLE.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.TEAM_MEMBER_ROLE.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.TEAM_MEMBER_ROLE.FETCH_ALL_REJECTED",
  },
  ISSUE: {
    FETCH: "QMS.ISSUE.FETCH",
    FETCH_FULFILLED: "QMS.ISSUE.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.ISSUE.FETCH_REJECTED",
    FETCH_ALL: "QMS.ISSUE.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.ISSUE.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.ISSUE.FETCH_ALL_REJECTED",
    FETCH_CHILDREN: "QMS.ISSUE.FETCH_CHILDREN",
    FETCH_CHILDREN_FULFILLED: "QMS.ISSUE.FETCH_CHILDREN_FULFILLED",
    FETCH_CHILDREN_REJECTED: "QMS.ISSUE.FETCH_CHILDREN_REJECTED",
    ADD: "QMS.ISSUE.ADD",
    ADD_FULFILLED: "QMS.ISSUE.ADD_FULFILLED",
    ADD_REJECTED: "QMS.ISSUE.ADD_REJECTED",
    ADD_CHILD: "QMS.ISSUE.ADD_CHILD",
    ADD_CHILD_FULFILLED: "QMS.ISSUE.ADD_CHILD_FULFILLED",
    ADD_CHILD_REJECTED: "QMS.ISSUE.ADD_CHILD_REJECTED",
    CLOSE: "QMS.ISSUE.CLOSE",
    CLOSE_FULFILLED: "QMS.ISSUE.CLOSE_FULFILLED",
    CLOSE_REJECTED: "QMS.ISSUE.CLOSE_REJECTED",
    OPEN: "QMS.ISSUE.OPEN",
    OPEN_FULFILLED: "QMS.ISSUE.OPEN_FULFILLED",
    OPEN_REJECTED: "QMS.ISSUE.OPEN_REJECTED",
    REMOVE: "QMS.ISSUE.REMOVE",
    REMOVE_FULFILLED: "QMS.ISSUE.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.ISSUE.REMOVE_REJECTED",
    UPDATE: "QMS.ISSUE.UPDATE",
    UPDATE_FULFILLED: "QMS.ISSUE.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.ISSUE.UPDATE_REJECTED",
    UPDATE_CLIENT: "QMS.ISSUE.UPDATE_CLIENT",
    ACTION_ITEMS: {
      ADD_CLIENT: "QMS.ISSUE.ACTION_ITEMS.ADD_CLIENT",
      REMOVE_CLIENT: "QMS.ISSUE.ACTION_ITEMS.REMOVE_CLIENT",
      UPDATE_CLIENT: "QMS.ISSUE.ACTION_ITEMS.UPDATE_CLIENT",
    },
    CLEAR_LIST: "QMS.ISSUE.CLEAR_LIST",
  },
  ISSUE_STAGE: {
    FETCH: "QMS.ISSUE_STAGE.FETCH",
    FETCH_FULFILLED: "QMS.ISSUE_STAGE.FETCH_FULFILLED",
    FETCH_REJECTED: "QMS.ISSUE_STAGE.FETCH_REJECTED",
    ADD: "QMS.ISSUE_STAGE.ADD",
    ADD_FULFILLED: "QMS.ISSUE_STAGE.ADD_FULFILLED",
    ADD_REJECTED: "QMS.ISSUE_STAGE.ADD_REJECTED",
    REMOVE: "QMS.ISSUE_STAGE.REMOVE",
    REMOVE_FULFILLED: "QMS.ISSUE_STAGE.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.ISSUE_STAGE.REMOVE_REJECTED",
    UPDATE: "QMS.ISSUE_STAGE.UPDATE",
    UPDATE_FULFILLED: "QMS.ISSUE_STAGE.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.ISSUE_STAGE.UPDATE_REJECTED",
    ADD_POST: "QMS.ISSUE_STAGE.ADD_POST",
    ADD_POST_FULFILLED: "QMS.ISSUE_STAGE.ADD_POST_FULFILLED",
    ADD_POST_REJECTED: "QMS.ISSUE_STAGE.ADD_POST_REJECTED",
    UPDATE_POST: "QMS.ISSUE_STAGE.UPDATE_POST",
    UPDATE_POST_FULFILLED: "QMS.ISSUE_STAGE.UPDATE_POST_FULFILLED",
    UPDATE_POST_REJECTED: "QMS.ISSUE_STAGE.UPDATE_POST_REJECTED",
    REMOVE_POST: "QMS.ISSUE_STAGE.REMOVE_POST",
    REMOVE_POST_FULFILLED: "QMS.ISSUE_STAGE.REMOVE_POST_FULFILLED",
    REMOVE_POST_REJECTED: "QMS.ISSUE_STAGE.REMOVE_POST_REJECTED",
    ADD_POST_UPVOTE: "QMS.ISSUE_STAGE.ADD_POST_UPVOTE",
    ADD_POST_UPVOTE_FULFILLED: "QMS.ISSUE_STAGE.ADD_POST_UPVOTE_FULFILLED",
    ADD_POST_UPVOTE_REJECTED: "QMS.ISSUE_STAGE.ADD_POST_UPVOTE_REJECTED",
    ADD_POST_DOWNVOTE: "QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE",
    ADD_POST_DOWNVOTE_FULFILLED: "QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE_FULFILLED",
    ADD_POST_DOWNVOTE_REJECTED: "QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE_REJECTED",
    UPDATE_CLIENT: "QMS.ISSUE_STAGE.UPDATE_CLIENT",
    CLEAR: "QMS.ISSUE_STAGE.CLEAR",
  },
  ISSUE_THREAD: {
    FETCH_ALL: "QMS.ISSUE_THREAD.FETCH_ALL",
    FETCH_ALL_FULFILLED: "QMS.ISSUE_THREAD.FETCH_ALL_FULFILLED",
    FETCH_ALL_REJECTED: "QMS.ISSUE_THREAD.FETCH_ALL_REJECTED",
    ADD: "QMS.ISSUE_THREAD.ADD",
    ADD_FULFILLED: "QMS.ISSUE_THREAD.ADD_FULFILLED",
    ADD_REJECTED: "QMS.ISSUE_THREAD.ADD_REJECTED",
    REMOVE: "QMS.ISSUE_THREAD.REMOVE",
    REMOVE_FULFILLED: "QMS.ISSUE_THREAD.REMOVE_FULFILLED",
    REMOVE_REJECTED: "QMS.ISSUE_THREAD.REMOVE_REJECTED",
    UPDATE: "QMS.ISSUE_THREAD.UPDATE",
    UPDATE_FULFILLED: "QMS.ISSUE_THREAD.UPDATE_FULFILLED",
    UPDATE_REJECTED: "QMS.ISSUE_THREAD.UPDATE_REJECTED",
  },
};
